import { axios, getAxiosConfig } from '@config/axios';
import Environment from '@config/index';
import { ApiResponse } from '@interfaces/api';
import { Product } from '@interfaces/models/product';

export type SortOrder = 'price' | 'recentPriceDrop' | 'priceDesc' | 'date' | 'dateDesc' | null;

export type RecommendationQuery = {
  limit?: number;
  offset: number;
  order: string | SortOrder;
  userId?: string | string[];
  source: string | string[];
  campaign: string | string[];
};

const DEFAULT_LIMIT = 20;
const BASE_URL = Environment.apiBaseUrl;

export const getRecommendedProducts = async (query: RecommendationQuery): Promise<ApiResponse<Product[]>> => {
  const { userId, campaign, source, order, offset, limit = DEFAULT_LIMIT } = query;
  const axiosConfig = getAxiosConfig();
  axiosConfig.params = {
    ...axiosConfig.params,
    order,
    limit,
    offset,
    campaign,
    source,
    userId,
  };

  const { data } = await axios.get<ApiResponse<Product[]>>(`${BASE_URL}/users/recommended-products`, axiosConfig);
  return data;
};
